export enum StepState {
  Completed = 'completed',
  Current = 'current',
  Upcoming = 'upcoming',
}
